export default function () {
  return [
    {name: 'Jan', product1: 400, product2: 240, amt: 2400},
    {name: 'Feb', product1: 300, product2: 139, amt: 2210},
    {name: 'Mar', product1: 200, product2: 980, amt: 2290},
    {name: 'Apr', product1: 278, product2: 390, amt: 2000},
    {name: 'May', product1: 189, product2: 480, amt: 2181},
    {name: 'Jun', product1: 239, product2: 380, amt: 2500},
    {name: 'Jul', product1: 349, product2: 430, amt: 2100},
  ]
};



// WEBPACK FOOTER //
// ./src/reducers/chart-reducers/lineChartReducers.js